import { useState } from 'react';
import { GoogleAddress } from 'src/models/GoogleAddress';
import useLocalStorage from './useLocalStorage';

export const useAddress = () => {
  const [address, setAddress] = useLocalStorage<GoogleAddress>(
    'currentAddress',
    {} as GoogleAddress
  );
  const [addressDetail, setAddressDetail] = useLocalStorage<string>('addressDetail', '');
  const [zoneId, setZoneId] = useLocalStorage<string>('zoneId', '');

  const [disabledDetail, setDisabledDetail] = useState(false);
  const [error, setError] = useState(false);

  const handleEditAddress = (newAddress: GoogleAddress) => {
    setAddress(newAddress);
  };

  const handleZoneId = (zoneId: string) => {
    setZoneId(zoneId);
  };

  const handleEditAddressDetail = (detail: string) => {
    setError(false);
    setAddressDetail(detail);
  };

  const handleDisabledDetail = () => {
    setDisabledDetail(!disabledDetail);
    setError(false);
  };

  const removeAddress = () => {
    setAddress({} as GoogleAddress);
  };

  const haveDetail = disabledDetail || (addressDetail !== null && addressDetail !== '');

  return {
    address,
    handleEditAddress,
    addressDetail,
    handleEditAddressDetail,
    disabledDetail,
    handleDisabledDetail,
    haveDetail,
    error,
    setError,
    handleZoneId,
    zoneId,
    removeAddress,
  };
};
